<template>
    <div class="container" style="margin-top: 145px;">
        <h1 :class="{'text-dark': isActive2, 'text-light': isActive3}" class="displayMain mt-5">Paquetes</h1>

        <div class="accordion accordion-flush mt-5 mb-5"  id="accordionExample">
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style="border-radius: 16px;">
                        <i class="fa-solid fa-star mr-2"></i>Promociones Vigentes
                    </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?
            txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
            lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapseTwo">
                        <i class="fa-solid fa-dragon mr-2"></i>Europa
                    </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=1&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="headingThree">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapseThree">
                        <i class="fa-solid fa-mosque mr-2"></i>Medio Oriente
                    </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=2&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading4">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse4" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse4">
                        <i class="fa-brands fa-canadian-maple-leaf mr-2"></i>Canada
                    </button>
                </h2>
                <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=3&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading5">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse5" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse5">
                        <i class="fa-solid fa-vihara mr-2"></i>Asia
                    </button>
                </h2>
                <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=4&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading6">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse6" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse6">
                        <i class="fa-solid fa-earth-africa mr-2"></i>África
                    </button>
                </h2>
                <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=5&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading7">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse7" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse7">
                        <i class="fa-solid fa-umbrella-beach mr-2"></i>Pacífico
                    </button>
                </h2>
                <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=6&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading8">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse8" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse8">
                        <i class="fa-solid fa-earth-americas mr-2"></i>Sudamérica
                    </button>
                </h2>
                <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=7&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading9">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse9" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse9">
                        <i class="fa-solid fa-flag-usa mr-2"></i>Estados Unidos
                    </button>
                </h2>
                <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=8&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading10">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse10" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse10">
                        <i class="fa-solid fa-bridge-water mr-2"></i>Centroamérica
                    </button>
                </h2>
                <div id="collapse10" class="accordion-collapse collapse" aria-labelledby="heading10"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=9&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading11">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse11" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse11">
                        <i class="fa-solid fa-person-swimming mr-2"></i>Cuba y el Caribe
                    </button>
                </h2>
                <div id="collapse11" class="accordion-collapse collapse" aria-labelledby="heading11"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=10&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading12">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse12" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse12">
                        <i class="fa-solid fa-church mr-2"></i>Nacionales
                    </button>
                </h2>
                <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=11&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading12">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse12" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse12">
                        <i class="fa-solid fa-wand-magic-sparkles mr-2"></i>Eventos Especiales
                    </button>
                </h2>
                <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=12&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
            <div class="accordion-item my-1" style="border-radius: 16px;">
                <h2 class="accordion-header" id="heading13">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse13" aria-expanded="false" style="border-radius: 16px;" aria-controls="collapse13">
                        <i class="fa-solid fa-ship mr-2"></i>Cruceros
                    </button>
                </h2>
                <div id="collapse13" class="accordion-collapse collapse" aria-labelledby="heading13"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        <iframe src="https://www.megatravel.com.mx/tools/vi.php?Dest=13&
        txtColor=1D1D1D&lblTPaq=9900FF&lblTRange=570090&
        lblNumRange=9900FF&itemBack=D5D5D5&ItemHov=360058&txtColorHov=ffffff&ff=1&ff=7&itemBack=ffff"
                            class="col-12 mb-5 mt-5" style="height: 100vh" border="0" align="center"
                            allowtransparency="true" frameborder="0"> </iframe>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-5 mb-4 bg-light rounded-3">
            <div class="row">
                <div class="col-12 col-md-6">
                    <h3>¿Desea contratar un paquete? Sigue estos sencillos pasos.</h3>
                    <p class="mt-5"><b>Selecciona tu producto</b></p>
                    <p>Paquetes, Translados, Hoteles </p>
                    <p class="mt-5"><b>Contactanos</b></p>
                    <p>Mandanos mensaje de whats app, dando click en <b>Contactanos</b> </p>
                    <p class="mt-5"><b>Si desea un asesoría </b></p>
                    <p>También puedes solicitar tu asesoría para adaptarnos a tus necesidades y presupuesto.</p>
                </div>
                <div class="col-12 col-md-6 row justify-content-center justify-content-md-end mt-5 mt-md-0">
                    <div class="col-12 col-md-8">
                        <img src="{{ asset('img/a2aba42c22089b09ee32c84071cf53ee.png') }}" class="img-fluid rounded-top"
                            alt="" />
                    </div>


                </div>
            </div>
        </div>
        <hr class="hr">
        <div class="row mb-5 row justify-content-center col-12 invisible-until-animate animate__animated"
            style="position: relative; left: 10px;">
            <div class="col-12 col-md-6 text-center">
                <h5>Agenda tu asesoría</h5>
            </div>
            <div class="col-12 col-md-6 row justify-content-center">
                <div class="col-12 col-md-6  row">
                    <button type="button" class="btn btn-dark mt-3 mt-md-0">
                        <i class="fa-solid fa-phone"></i> Contactanos
                    </button>
                </div>


            </div>
        </div>
    </div>

</template>
<script>
export default {
    name: "PaquetesWeb",
    data() {
        return {};
    },
    props: ["isActive2", "isActive3"],
    components: {},
    methods: {},
    mounted() { },
};
</script>